import React, { useState, useEffect } from 'react';
import { 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope, 
  FaPaperPlane, 
  FaUser, 
  FaBuilding,
  FaComment,
  FaClock,
  FaWhatsapp,
  FaLocationArrow,
  FaHospital
} from 'react-icons/fa';

const CompactContactSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message sent successfully! We will contact you soon.');
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: ''
    });
  };

  return (
    <section className="py-12 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
            Get in Touch
          </h2>
          <p className="text-gray-600 text-sm max-w-md mx-auto">
            Contact us for appointments or inquiries. We're here to help with all your urological needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Left Column – Contact Info & Map */}
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Address Card (already correct) */}
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-start mb-3">
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3 flex-shrink-0">
                    <FaMapMarkerAlt className="text-blue-600 text-sm" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-sm mb-1">Address</h4>
                    <p className="text-gray-600 text-xs">
                    City Clinic, 1st Floor, RIMS Medical Chowk, Opposite Jharkhand Eye Bank Hospital, Bariatu, Ranchi, PIN- 834009, Ranchi, Jharkhand 834009
                    </p>
                  </div>
                </div>
              </div>
              {/* Other cards unchanged */}
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-start mb-3">
                  <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0">
                    <FaPhone className="text-green-600 text-sm" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-sm mb-1">Phone</h4>
                    <p className="text-gray-600 text-xs">
                      +91 8002280222<br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-start mb-3">
                  <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center mr-3 flex-shrink-0">
                    <FaEnvelope className="text-purple-600 text-sm" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-sm mb-1">Email</h4>
                    <p className="text-gray-600 text-xs">
                      aarogyavijayofficial@gmail.com<br />
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300">
                <div className="flex items-start mb-3">
                  <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center mr-3 flex-shrink-0">
                    <FaClock className="text-amber-600 text-sm" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 text-sm mb-1">Hours</h4>
                    <p className="text-gray-600 text-xs">
                      Mon-Fri: 9AM-8PM<br />
                      Sat: 9AM-6PM<br />
                      Sun: Emergency
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map Section – REPLACED with real Google Maps embed */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="p-4 border-b border-gray-200">
                <div className="flex items-center">
                  <FaHospital className="text-blue-600 mr-2" />
                  <h3 className="font-semibold text-gray-800 text-sm">Our Location</h3>
                </div>
              </div>
              
              {/* Embedded Google Map */}
              <div className="h-64 w-full">
                <iframe
                  title="City Clinic Location"
                  src="https://maps.google.com/maps?q=City%20Clinic%2C%201st%20Floor%2C%20RIMS%20Medical%20Chowk%2C%20Opposite%20Jharkhand%20Eye%20Bank%20Hospital%2C%20Bariatu%2C%20Ranchi%2C%20PIN-%20834009%2C%20Ranchi%2C%20Jharkhand%20834009&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div className="p-3 bg-gray-50 border-t border-gray-200 flex justify-between items-center">
                <p className="text-gray-600 text-xs">
                  <span className="font-medium">Directions:</span> Near Medical Chowk, Main Road, Ranchi
                </p>
                <a 
                  href="https://maps.google.com/?q=City+Clinic,+1st+Floor,+RIMS+Medical+Chowk,+Opposite+Jharkhand+Eye+Bank+Hospital,+Bariatu,+Ranchi,+PIN-834009,+Jharkhand"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-xs bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors"
                >
                  <FaMapMarkerAlt className="mr-1 text-xs" />
                  Open in Maps
                </a>
              </div>
            </div>

            {/* Emergency Contact – unchanged */}
            <div className="bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500 p-4 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="font-bold text-red-700 text-sm">Emergency Contact</h4>
                  <p className="text-red-600 text-xs">24/7 Available</p>
                </div>
                <a 
                  href="tel:+918002280222"
                  className="bg-red-600 text-white text-xs px-3 py-2 rounded hover:bg-red-700 transition-colors flex items-center"
                >
                  <FaPhone className="mr-1" />
                  Call Now
                </a>
              </div>
            </div>
          </div>

          {/* Right Column – Form (unchanged) */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="mb-6">
              <h3 className="font-bold text-gray-800 text-lg mb-2 flex items-center">
                <FaPaperPlane className="text-blue-600 mr-2" />
                Send Us a Message
              </h3>
              <p className="text-gray-600 text-sm">
                Fill out the form below and we'll get back to you as soon as possible.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* ... form fields (unchanged) ... */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-xs font-medium mb-1">
                    <FaUser className="inline mr-1 text-gray-400" />
                    First Name *
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter first name"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 text-xs font-medium mb-1">
                    Last Name *
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="Enter last name"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-xs font-medium mb-1">
                    <FaPhone className="inline mr-1 text-gray-400" />
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="+91 8002280222"
                  />
                </div>
                
                <div>
                  <label className="block text-gray-700 text-xs font-medium mb-1">
                    <FaEnvelope className="inline mr-1 text-gray-400" />
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="you@example.com"
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 text-xs font-medium mb-1">
                  <FaBuilding className="inline mr-1 text-gray-400" />
                  Company (Optional)
                </label>
                <input
                  type="text"
                  name="company"
                  onChange={handleChange}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                  placeholder="Your company name"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-xs font-medium mb-1">
                  <FaComment className="inline mr-1 text-gray-400" />
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all resize-none"
                  placeholder="Describe your requirements or concerns..."
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-blue-800 text-white py-3 rounded-lg font-medium hover:from-blue-700 hover:to-blue-900 transition-all duration-300 shadow-sm hover:shadow"
              >
                Send Message
              </button>
              <p className="text-gray-500 text-xs text-center mt-3">
                By submitting this form, you agree to our privacy policy.
              </p>
            </form>
            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-gray-700 text-xs">
                  <span className="font-medium">Prefer WhatsApp?</span>
                  <p className="text-gray-500">Chat with us for quick responses</p>
                </div>
                <a 
                  href="https://wa.me/918002280222"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-green-600 text-white text-xs px-3 py-2 rounded hover:bg-green-700 transition-colors"
                >
                  <FaWhatsapp className="mr-1" />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom badges – unchanged */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
            <div className="flex items-center">
              <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                <FaClock className="text-blue-600" />
              </div>
              <div>
                <h4 className="font-medium text-gray-800 text-sm">Quick Response</h4>
                <p className="text-gray-600 text-xs">Response within 24 hours</p>
              </div>
            </div>
          </div>
          
          <div className="bg-green-50 p-3 rounded-lg border border-green-100">
            <div className="flex items-center">
              <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3">
                <FaUser className="text-green-600" />
              </div>
              <div>
                <h4 className="font-medium text-gray-800 text-sm">Expert Consultation</h4>
                <p className="text-gray-600 text-xs">Directly with Dr. Shukla</p>
              </div>
            </div>
          </div>
          
          <div className="bg-purple-50 p-3 rounded-lg border border-purple-100">
            <div className="flex items-center">
              <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center mr-3">
                <FaHospital className="text-purple-600" />
              </div>
              <div>
                <h4 className="font-medium text-gray-800 text-sm">Modern Facility</h4>
                <p className="text-gray-600 text-xs">Advanced medical equipment</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompactContactSection;